import React from 'react';
import type { FC } from 'react';

interface WarningIconProps {
    className?: string;
}

export const WarningIcon: FC<WarningIconProps> = ({ className }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>Warning Icon</title>
            <path d="M10 6L10 11" stroke="#FE9549" strokeWidth="1.11111" />
            <path d="M10 12L10 14" stroke="#FE9549" strokeWidth="1.11111" />
            <ellipse cx="9.99956" cy="10.0035" rx="7.22222" ry="7.22222" stroke="#FE9549" strokeWidth="1.11111" />
        </svg>
    );
};
